import React from "react";

const ErrorMsg = () => {
  return(
    <h2 className="errorMsg">We couldn't find what you were looking for.</h2>
  )
}

export default ErrorMsg;
